import { useState } from "react";
import { Link } from "react-router-dom";
import FounderNoteManage from "./FounderNoteEditor";
import FaqCategoriesManage from "./FaqCategories";
import FaqManage from "../Faq";
import AboutManage from "./AboutSections";

export default function PartnerCMS() {
    const [activeState,setActiveState]=useState("")
  const rows = [
    { name: "Founder Note", path: "/cms/founder-note", type:"founder-note" },
    { name: "FAQs Category", path: "/cms/faq-categories",type:"faq-categories" },
    { name: "About Section", path: "/cms/about",type:"about" },
  ];

  const handleState=(value)=>{
    setActiveState(value)
  }

  return (
    <div className=" mx-auto">
        {activeState ? (
            <div className="p-4">
                <span onClick={()=>handleState("")} className="p-4 cursor-pointer">Back</span>
            </div>
        ):(

            ""
        ) 
    }


    {activeState==="" && (
      <div className="overflow-hidden border rounded-2xl shadow-sm bg-white">
        <div className="px-4 py-3 border-b bg-gray-50/60">
          <h2 className="text-base font-semibold text-gray-900">Modules</h2>
        </div>
        <div className="overflow-x-auto">
          <table className="min-w-full border-collapse">
            <thead className="bg-gray-50 text-gray-700">
              <tr>
                <th className="text-left p-3 border-b">S.No.</th>
                <th className="text-left p-3 border-b">Name</th>
                <th className="text-left p-3 border-b">Actions</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={r.path} className="odd:bg-white even:bg-gray-50">
                  <td className="p-3 border-b">{i + 1}</td>
                  <td className="p-3 border-b">{r.name}</td>
                  <td className="p-3 border-b">
                    <span
                      onClick={()=>handleState(r.type)}
                      className="inline-flex cursor-pointer items-center gap-2 px-3 py-1.5 rounded-lg border border-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-300"
                    >
                      Open
                    </span>
                    {/* <Link
                      to={r.path}
                      className="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg border border-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-300"
                    >
                      Open
                    </Link> */}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
)}

      {activeState==="founder-note" && (
        <FounderNoteManage />
      )}
      {activeState==="faq-categories" && (
        <FaqCategoriesManage />
      )}
      {activeState==="about" && (
        <AboutManage />
      )}


    </div>
  );
}
